/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { IErrorMessage } from "../../../models/Machines/ClientContracts"
import { IMeasureGroup, IMeasures } from "../../../models/Policies/PolicyContract"
import { GET_ALL_MEASURES, GET_ALL_MEASURE_GROUP, SET_MEASURES_FORM_DATA, SET_POLICY_MEASURES_FORM_ERROR, UPDATE_POLICY_MEASURES_FORM_ERROR } from "./types"

export const measureInitialState: {
  measures: IMeasures[],
  measureGroup: IMeasureGroup[],
  error: IErrorMessage[],
  measureFormData: any,
  measureFormError: any,
} = {
  measures: [],
  measureGroup: [],
  error: [],
  measureFormData: {
    isMeasureGroup: true,
    policyName: '',
    policyMeasures: '',
    policyDescription: '',
    policyAction: [],
    policyMeasureGroup: ''
  },
  measureFormError: {
    policyName: '',
    policyMeasures: '',
    policyDescription: '',
    policyAction: '',
    policyMeasureGroup: ''
  },
}

export const measureReducer = (state = measureInitialState, action: any) => {
  switch (action.type) {
    case GET_ALL_MEASURES:
      return {
        ...state,
        measures: action.measures
      }
    case GET_ALL_MEASURE_GROUP:
      return {
        ...state,
        measureGroup: action.measureGroup
      }
    case SET_MEASURES_FORM_DATA:
      return {
        ...state,
        measureFormData: { ...state.measureFormData, ...action.data }
      }
    case SET_POLICY_MEASURES_FORM_ERROR:
      return {
        ...state,
        measureFormError: action.errorData
      }
    case UPDATE_POLICY_MEASURES_FORM_ERROR:
      return {
        ...state,
        measureFormError: { ...state.measureFormError, ...action.data }
      }
    default:
      return state;
  }
}